import { useTranslation } from 'react-i18next';

import { ErrorContainer } from './ErrorElement.styles';
import { useNavigate } from 'react-router-dom';

const ErrorElenment = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const goHome = () => {
		navigate('/');
	};
	return (
		<>
			<ErrorContainer>
				<div className="error-content">
					<div className="error_text">
						<h2 className="oops">{t('OOPS!')}</h2>
						<h4 className="sth-wrong">{t('SOMETHING WENT WRONG')}</h4>
						<p className="error-des ">{t("errorEl")}</p>
					</div>
					<div>
						<button className="go-home_btn" onClick={goHome}>
							{t('BACK TO HOME')}
						</button>
					</div>
				</div>
			</ErrorContainer>
		</>
	);
};

export default ErrorElenment;
